var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportador(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_16619)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.184,
    height: 17.0632,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0124 0.31781C1.08565 0.31781 0.335118 1.05766 0.335118 1.96075L0.326416 15.1021C0.326416 16.0052 1.07695 16.7451 2.0037 16.7451H12.1261C13.0529 16.7451 13.8121 16.0052 13.8121 15.1021V5.58581C13.8121 5.36746 13.7229 5.15971 13.5663 5.00495L9.00217 0.557361C8.84336 0.402607 8.63017 0.31781 8.40609 0.31781H2.0124Z",
    fill: "#150B99",
    stroke: "#1155BB",
    strokeWidth: 0.947958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0592 7.43616H5.38424C4.76307 7.43616 4.25952 7.92685 4.25952 8.53216V12.3629C4.25952 12.9682 4.76307 13.4589 5.38424 13.4589H16.0592C16.6804 13.4589 17.184 12.9682 17.184 12.3629V8.53216C17.184 7.92685 16.6804 7.43616 16.0592 7.43616Z",
    fill: "url(#paint0_linear_999_16619)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44434 9.87615L8.28407 8.47064H9.08464L7.87726 10.4019L9.11292 12.3649H8.30365L7.44434 10.9382L6.58285 12.3649H5.77576L7.0136 10.4019L5.80404 8.47064H6.60461L7.44434 9.87615ZM10.3203 11.8222H12.1346V12.3628H9.62633V8.47064H10.3203V11.8222ZM14.7539 11.3601C14.7539 11.1884 14.693 11.0569 14.569 10.9637C14.445 10.8704 14.2231 10.7771 13.9011 10.6838C13.5791 10.5884 13.3224 10.4846 13.1332 10.368C12.7699 10.1454 12.5871 9.85495 12.5871 9.49669C12.5871 9.18294 12.7177 8.92431 12.9809 8.7208C13.2441 8.51728 13.5835 8.41553 14.0034 8.41553C14.2818 8.41553 14.5298 8.46641 14.7474 8.56604C14.9649 8.66568 15.1368 8.80771 15.2608 8.99215C15.3848 9.17658 15.4479 9.38009 15.4479 9.6048H14.7561C14.7561 9.40129 14.6908 9.2423 14.5603 9.12782C14.4298 9.01335 14.2427 8.95611 13.999 8.95611C13.7728 8.95611 13.5966 9.00274 13.4704 9.09814C13.3442 9.19354 13.2833 9.32497 13.2833 9.49457C13.2833 9.6366 13.3507 9.75532 13.4856 9.85071C13.6205 9.94611 13.8446 10.0394 14.1556 10.1284C14.4667 10.2175 14.7169 10.3213 14.904 10.4358C15.0933 10.5503 15.2303 10.6817 15.3173 10.8322C15.4044 10.9806 15.45 11.1545 15.45 11.3559C15.45 11.6802 15.3217 11.9388 15.0672 12.1296C14.8126 12.3204 14.4667 12.4179 14.0295 12.4179C13.7401 12.4179 13.4747 12.3649 13.2333 12.2611C12.9918 12.1572 12.8025 12.013 12.6676 11.8286C12.5328 11.6442 12.4653 11.4322 12.4653 11.1863H13.1593C13.1593 11.4067 13.2333 11.5784 13.3834 11.6993C13.5335 11.8201 13.7488 11.8816 14.0273 11.8816C14.2688 11.8816 14.4493 11.835 14.5712 11.7396C14.693 11.6442 14.7539 11.5191 14.7539 11.3622V11.3601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75562 5.77078V1.66449L12.3915 6.18204H8.17766C7.94488 6.18204 7.75562 5.99761 7.75562 5.77078Z",
    fill: "white",
    stroke: "#1155BB",
    strokeWidth: 0.423984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_999_16619",
    x1: 3,
    y1: 10,
    x2: 16.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1866C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_16619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.184,
    height: 17.0632,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportador);
export default __webpack_public_path__ + "static/media/importador.05acbeecbb9abe03f10e1e414fa03116.svg";
export { ForwardRef as ReactComponent };